import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {OverlayModule} from '@angular/cdk/overlay';
import 'hammerjs';
import {NgxPermissionsModule} from 'ngx-permissions';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {StoreRouterConnectingModule} from '@ngrx/router-store';
import {metaReducers, reducers} from './core/reducers';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {CoreModule} from './core/core.module';
import {PartialsModule} from './views/partials/partials.module';
import {
    KtDialogService,
    LayoutConfigService,
    LayoutRefService,
    MenuAsideService,
    MenuConfigService,
    MenuHorizontalService,
    PageConfigService,
    SplashScreenService,
    SubheaderService
} from './core/_base/layout';
import {AuthModule} from './views/pages/auth/auth.module';
import {AuthService, MobileAppService, SalesforceService} from './core/services';
import {FormService} from './core/services/form.service';


import {HttpUtilsService, LayoutUtilsService, TypesUtilsService} from './core/_base/crud';
import {HomePageService} from './core/services/homepage.service';
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '../environments/environment';

// 本番環境はキャッシュが強いので、アップデートで来たかがわかりにくいので、アップデート時刻を分までおおざっぱに書いておく。
console.log("Version 1.12.0: 2025-11-12T22:00:00", "notification badge update");

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserAnimationsModule,
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        NgxPermissionsModule.forRoot(),
        PartialsModule,
        CoreModule,
        OverlayModule,
        StoreModule.forRoot(reducers, {metaReducers}),
        EffectsModule.forRoot([]),
        StoreRouterConnectingModule.forRoot({stateKey: 'router'}),
        AuthModule.forRoot(),
        TranslateModule.forRoot(),
        MatProgressSpinnerModule,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
    ],
    exports: [],
    providers: [
        AuthService,
        SalesforceService,
        LayoutConfigService,
        LayoutRefService,
        MenuConfigService,
        PageConfigService,
        KtDialogService,
        SplashScreenService,
        FormService,
        SubheaderService,
        MenuHorizontalService,
        MenuAsideService,
        HttpUtilsService,
        TypesUtilsService,
        LayoutUtilsService,
        HomePageService,
        MobileAppService,
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
